<div class="app-input-wrapper">
  <label *ngIf="label" class="app-input-label">{{ label | translate }}</label>
  <input
    pInputText
    [type]="type"
    [placeholder]="(placeholder || '') | translate"
    [disabled]="disabled"
    [ngModel]="value || ''"
    (ngModelChange)="onChange($event)"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
    (input)="handleInput($event)"
    (keydown)="handleKeydown($event)"
    [step]="step || (type === 'number' ? '0.01' : '')"
    [min]="min"
    [ngClass]="{
      'p-inputtext-sm': size === 'small',
      'p-inputtext-lg': size === 'large',
      'p-filled': variant === 'filled',
      'p-outlined': variant === 'outlined',
      'disabled':disabled
    }"
    class="app-input"
  />
</div>
